<!-- Home slider start-->
<section class="px-0 py-3 px-lg-3">
  <div class="container">
    <div class="row slider-container1">
      <div class="col-md-12">
        <ng-container *ngIf="sliderdatadone; else noSlider">
          <app-slider
            [sliders]="sliders"
            [textClass]="'text-center'"
            [category]="'fashion'"
            [buttonText]="'shop now' | translate"
          >
          </app-slider>
        </ng-container>
        <ng-template #noSlider>
          <div class="fashion-loader">
            <img src="assets/images/loader.gif" />
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-container *ngIf="lastInSliderOffersdatadone; else noLastInSliderOffers">
    <app-fashion-offers
      [ProductsOffers]="lastInSliderOffers"
    ></app-fashion-offers>
  </ng-container>
  <ng-template #noLastInSliderOffers>
    <div class="fashion-loader">
      <img src="assets/images/loader.gif" />
    </div>
  </ng-template>
</section>
<!-- Home slider End -->

<!-- category 1 -->

<div class="container">
  <div
    class="px-0 title1 section-t-space"
    *ngIf="
      !categoriesdatadone ||
      (categoriestest?.length > 0 && categoriestestDesktop?.length > 0)
    "
  >
    <h2>{{ "categories" | translate }}</h2>
    <h2 class="title-inner1"></h2>
  </div>

  <section class="section-b-space categories">
    <div class="row">
      <div class="col">
        <ng-container *ngIf="categoriesdatadone; else noCategories">
          <app-categories-slider
            [itemsList]="categoriestest"
            [itemsListDesktop]="categoriestestDesktop"
          >
          </app-categories-slider>
        </ng-container>
        <ng-template #noCategories>
          <div class="fashion-loader">
            <img src="assets/images/loader.gif" />
          </div>
        </ng-template>
      </div>
    </div>
  </section>
</div>

<!-- lastCategoriesOffersdatadone banner start -->
<section class="pb-0" class="category-offers-section">
  <ng-container
    *ngIf="lastCategoriesOffersdatadone; else noLastCategoriesOffers"
  >
    <app-fashion-offers
      [ProductsOffers]="lastCategoriesOffers"
    ></app-fashion-offers>
  </ng-container>
  <ng-template #noLastCategoriesOffers>
    <div class="fashion-loader">
      <img src="assets/images/loader.gif" />
    </div>
  </ng-template>
</section>
<!-- lastCategoriesOffersdatadone banner End -->

<section class="brands-section">
  <div class="container">
    <div
      class="px-0 mt-3 title1 section-t-space"
      *ngIf="!brandsdatadone || brandstest?.length > 0"
    >
      <h2>{{ "brands" | translate }}</h2>
      <h2 class="title-inner1"></h2>
    </div>

    <ng-container *ngIf="brandsdatadone; else noBrands">
      <section class="brands">
        <div class="row">
          <div class="col">
            <app-brands-home-slider
              [itemsList]="brandstest | slice : 0 : 20"
              [itemsListDesktop]="brandstest | slice : 0 : 20"
            ></app-brands-home-slider>
          </div>
        </div>
      </section>
    </ng-container>
    <ng-template #noBrands>
      <div class="fashion-loader">
        <img src="assets/images/loader.gif" />
      </div>
    </ng-template>
  </div>
</section>

<!-- lastInrademarksOffersdatadone banner start -->
<section class="pb-0 last-in-trademarks-offers">
  <ng-container
    *ngIf="lastInrademarksOffersdatadone; else noLastInrademarksOffers"
  >
      <app-fashion-offers
        [ProductsOffers]="lastInrademarksOffers"
      ></app-fashion-offers>
  </ng-container>
  <ng-template #noLastInrademarksOffers>
    <div class="fashion-loader">
      <img src="assets/images/loader.gif" />
    </div>
  </ng-template>
</section>

<section class="p-t-0 product-slider">
  <div class="container">
    <div
      class="title1 section-t-space"
      *ngIf="!bestsellerdatadone || allBestSellerItems?.length > 0"
    >
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="flex-grow-1 title-inner1">
          {{ "best_seller" | translate }}
        </h2>
        <a [routerLink]="['/shop/category/best_seller']" class="btn all-btn">{{
          "show all" | translate
        }}</a>
      </div>
    </div>
    <ng-container *ngIf="bestsellerdatadone; else noBestSeller">
      <div class="row" *ngIf="allBestSellerItems.length > 0">
        <div class="col">
          <app-related-products-slider
            [productsList]="allBestSellerItems | slice : 0 : 9"
          ></app-related-products-slider>
        </div>
      </div>
    </ng-container>
    <ng-template #noBestSeller>
      <div class="fashion-loader">
        <img src="assets/images/loader.gif" />
      </div>
    </ng-template>
  </div>
</section>

<section class="p-t-0 product-slider">
  <div class="container">
    <div
      class="title1 section-t-space"
      *ngIf="!newdatadone || allNewestItems?.length > 0"
    >
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="flex-grow-1 title-inner1">
          {{ "New Products" | translate }}
        </h2>
        <a [routerLink]="['/shop/category/new']" class="btn all-btn">{{
          "show all" | translate
        }}</a>
      </div>
    </div>
    <ng-container *ngIf="newdatadone; else noNew">
      <div class="row">
        <div class="col" *ngIf="allNewestItems.length > 0">
          <app-related-products-slider
            [productsList]="allNewestItems | slice : 0 : 9"
          ></app-related-products-slider>
        </div>
      </div>
    </ng-container>
    <ng-template #noNew>
      <div class="fashion-loader">
        <img src="assets/images/loader.gif" />
      </div>
    </ng-template>
  </div>
</section>

<section class="pb-0 last-product-offer-section">
  <ng-container *ngIf="lastProductsOffersdatadone; else noLastProductsOffers">
      <app-fashion-offers
        [ProductsOffers]="lastProductsOffers"
      ></app-fashion-offers>
  </ng-container>
  <ng-template #noLastProductsOffers>
    <div class="fashion-loader">
      <img src="assets/images/loader.gif" />
    </div>
  </ng-template>
</section>
<section
  class="section-b-space p-t-0 product-slider"
  *ngIf="attachments_itemsdone && false"
>
  <div class="container">
    <div class="title1 section-t-space" *ngIf="attachments_itemsdone">
      <h2>{{ "attachments" | translate }}</h2>
      <h2 class="title-inner1"></h2>
    </div>
    <div class="row">
      <div class="col">
        <owl-carousel-o
          class="product-m no-arrow"
          [options]="ProductSliderConfig"
        >
          <ng-container
            *ngFor="let product of attachments_items | slice : 4 : 20"
          >
            <ng-template carouselSlide>
              <app-product-box-one
                [product]="product"
                [currency]="productService?.Currency"
                [thumbnail]="false"
                [cartModal]="true"
              >
              </app-product-box-one>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>
</section>

<ngx-json-ld [json]="organizationSchema"></ngx-json-ld>

<app-newsletter></app-newsletter>
